'use client';

import type { ProformAddrItem } from '@eliadmin/core/src/api/proform/proform-types';
import {
  AddrItem,
  CreateAddressDialog,
  useProformAddrQueryOpts,
} from '@eliadmin/core/src/components/cart/detail/proform-addr-picker';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { DialogTrigger } from '@eliadmin/core/src/components/ui/dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export default function AddressesPage() {
  const { t } = useTranslations();
  const addrQuery = useQuery(useProformAddrQueryOpts());
  const delItems = useMemo(() => {
    const delItems = addrQuery.data?.root.del_address_items?.del_address_item;

    if (!delItems) {
      return [];
    }

    let result: ProformAddrItem[] = [];
    if (Array.isArray(delItems)) {
      result = [...delItems].sort((a, b) => a.poradi.localeCompare(b.poradi));
    } else {
      result = [delItems];
    }

    return result;
  }, [addrQuery.data?.root.del_address_items?.del_address_item]);

  return (
    <>
      <div className="flex w-full flex-row items-center justify-between gap-4">
        <h4 className="text-xl font-bold">{t('text1475')}</h4>
        <CreateAddressDialog type="del">
          <DialogTrigger asChild>
            <Button>{t('text1114')}</Button>
          </DialogTrigger>
        </CreateAddressDialog>
      </div>
      <div className="mt-2 flex flex-row flex-wrap gap-8">
        {delItems.map(item => (
          <AddrItem key={item.poradi} item={item} isSelected={false} onClick={() => {}} />
        ))}
      </div>
    </>
  );
}
